import React from 'react';

const TestRoute = () => {
  return <h1>ok</h1>;
};

export default TestRoute;
